import missionsHistoryLocales from './missions'

export default {
  history: {
    title: {
      workerCounterCreated: 'Compteur créé',
      workerCounterUpdated: 'Compteur mis à jour',
      workerCounterActivated: 'Compteur activé',
      workerCounterDeactivated: 'Compteur désactivé',
      workerCounterValueAdjusted: 'Valeur du compteur ajustée'
    },
    changesTitle: {
      currentValue: 'Valeur du compteur',
    },
  },
}
